module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"chatsDialog.noChatsYet":"You haven\u0027t started any Cloud Intelligence chats yet."}}')
  delete Component.options._Ctor
}
